import React from 'react';

// tslint:disable max-line-length
const CChoosePart3Munch: React.FC = () => (
  <>
    <h5>Choosing part 3</h5>
    <p>Now it’s time to finish this off. Beginning: done. Middle: done. You need an ending.</p>
    <p>Does this person know you so well that they’ve already worked out what’s coming last? Push them a little bit. Right? Something they wouldn’t get for themselves. It’s not too late to surprise them?</p>
  </>
);

export {
  CChoosePart3Munch,
};
